import styled from "styled-components";
import { Button as AntButton } from "antd";

export const RootContainer = styled.div`
  background: #49028E;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 30px 16px;
  min-height: calc(100vh - 60px);
`;

export const SkipButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
`;

export const SkipButton = styled.div`
  cursor: pointer;
  color: #ffffff;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  text-decoration: underline;
`;

export const Image = styled.img.attrs({
    alt: "img",
  })`
    width: 300px;
    object-fit: contain;
  `;

export const Title = styled.div`
  color: #E8E03C;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  width: 50%;
  margin-bottom: 15px;

  @media screen and (max-width: 420px) {
    width: 60%;
  }
  @media screen and (max-width: 350px) {
    width: 70%;
  }
  @media screen and (max-width: 310px) {
    width: 80%;
  }
`;

export const Description = styled.div`
  color: #ffffff;
  font-size: 14px;
  font-weight: 400px;
  text-align: center;
  margin-bottom: 25px;

  span {
    font-weight: bold;
  }
  width: 55%;

  @media screen and (max-width: 420px) {
    width: 65%;
  }
  @media screen and (max-width: 350px) {
    width: 75%;
  }
  @media screen and (max-width: 310px) {
    width: 85%;
  }
`;

export const RuleTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FFFFFF33;
  border-radius: 8px;
  padding: 4px 12px 4px 12px;
`;

export const RuleTitle = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5;
  color: #fff;
`;

export const Rule = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  color: #CCC;

  padding: 16px;
  border-radius: 0px 0px 12px 12px;
  margin-bottom: 25px;
  width: calc(100% - 32px);
  text-align: left;
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const Button = styled(AntButton)`
  width: 100% !important;
  height: 48px !important;
  color: #FFFFFF !important;
  background: ${(props) =>
    props.copy === "copy"
      ? "none"
      : "#9027E1"} !important;
  border: 1px solid ${(props) => (props.copy === "copy" ? "#E5E0F5" : "#9027E1")} !important;
  border-radius: 16px !important;

  :hover {
    background: ${(props) =>
      props.copy === "copy"
        ? "none"
        : "#9027E1"} !important;
    border: 1px solid ${(props) => (props.copy === "copy" ? "#E5E0F5" : "#9027E1")} !important;
    color: #FFFFFF !important;
  }
`;
